/* ==========================================================
   custom-options.bundle.js
   Horizon-safe bundle add to cart
   - No variants on main product
   - Options saved as line item properties
   - Add-ons added as hidden variants
   - Prevent double add (capture click + capture submit)
   - Logo upload to Cloudinary -> save URL to properties
   ========================================================== */

(function () {

  /* ================= CONFIG ================= */

  const CLOUDINARY = {
    cloudName: "dyvicnw2c",
    uploadPreset: "shopify_logo_upload"
  };

  const ADDON_VARIANTS = {
    team_name: 44921762709695,
    your_name: 44921762742463,
    front_number: 44921762775231,
    back_number: 44921762807999,
    material_stitched: 44921762840767,
    material_print: 44922683687103,
    logo1: 44921762873535,
    logo2: 44921762906303
  };

  const OPTION_CONFIG = {
    gender: { label: "Gender" },
    size: { label: "Size" },

    team_name: { label: "Team Name", feeVariantId: ADDON_VARIANTS.team_name },
    your_name: { label: "Your Name", feeVariantId: ADDON_VARIANTS.your_name },
    front_number: { label: "Front Number", feeVariantId: ADDON_VARIANTS.front_number },
    back_number: { label: "Back Number", feeVariantId: ADDON_VARIANTS.back_number },

    material: {
      label: "Material",
      feeByValue: {
        Embroidered: ADDON_VARIANTS.material_stitched,
        Sublimated: ADDON_VARIANTS.material_print
      }
    },

    logo_1: { label: "1ST Logo Location(Optional)", feeVariantId: ADDON_VARIANTS.logo1 },
    logo_2: { label: "2ND Logo Location(Optional)", feeVariantId: ADDON_VARIANTS.logo2 }
  };

  /* ================= HELPERS ================= */

  const qs  = (r, s) => r.querySelector(s);
  const qsa = (r, s) => Array.from(r.querySelectorAll(s));

  function uuid() {
    return crypto.randomUUID ? crypto.randomUUID() : "b_" + Date.now() + Math.random();
  }

  function findForm(container) {
    return container.closest("form[action*='/cart/add']") ||
           document.querySelector("form[action*='/cart/add']");
  }

  function getVariantId(form) {
    return Number(qs(form, 'input[name="id"]')?.value);
  }

  function getQty(form) {
    return Number(qs(form, 'input[name="quantity"]')?.value || 1);
  }

  /* ================= LOGO UPLOAD (Cloudinary) ================= */

  function toggleLogoUpload(container) {
    ["logo_1", "logo_2"].forEach((k) => {
      const sel = container.querySelector(`[data-option-select="${k}"]`);
      const box = container.querySelector(`[data-logo-upload="${k}"]`);
      if (!sel || !box) return;

      const show = sel.value && sel.value !== "None";
      box.hidden = !show;

      if (!show) {
        const file = container.querySelector(`[data-logo-file="${k}"]`);
        const urlInput = container.querySelector(`[data-logo-url="${k}"]`);
        const status = container.querySelector(`[data-upload-status="${k}"]`);
        if (file) file.value = "";
        if (urlInput) urlInput.value = "";
        if (status) status.textContent = "";
      }
    });
  }

  async function uploadToCloudinary(file) {
    const url = `https://api.cloudinary.com/v1_1/${CLOUDINARY.cloudName}/upload`;
    const fd = new FormData();
    fd.append("file", file);
    fd.append("upload_preset", CLOUDINARY.uploadPreset);

    const res = await fetch(url, { method: "POST", body: fd });
    if (!res.ok) throw new Error("Upload failed");
    const data = await res.json();
    return data.secure_url;
  }

  function bindLogoUpload(container) {
    // create hidden holders for URL
    ["logo_1", "logo_2"].forEach((k) => {
      let hidden = container.querySelector(`[data-logo-url="${k}"]`);
      if (!hidden) {
        hidden = document.createElement("input");
        hidden.type = "hidden";
        hidden.setAttribute("data-logo-url", k);
        container.appendChild(hidden);
      }
    });

    ["logo_1", "logo_2"].forEach((k) => {
      const sel = container.querySelector(`[data-option-select="${k}"]`);
      const fileInput = container.querySelector(`[data-logo-file="${k}"]`);
      const status = container.querySelector(`[data-upload-status="${k}"]`);
      const hidden = container.querySelector(`[data-logo-url="${k}"]`);

      if (sel && !sel.dataset.logoBound) {
        sel.dataset.logoBound = "1";
        sel.addEventListener("change", () => toggleLogoUpload(container));
      }

      if (fileInput && !fileInput.dataset.logoBound) {
        fileInput.dataset.logoBound = "1";
        fileInput.addEventListener("change", async () => {
          if (!fileInput.files || !fileInput.files[0]) return;

          if (!CLOUDINARY.cloudName || !CLOUDINARY.uploadPreset) {
            alert("Missing Cloudinary config.");
            return;
          }

          try {
            if (status) status.textContent = "Uploading...";
            const url = await uploadToCloudinary(fileInput.files[0]);
            hidden.value = url;
            if (status) status.textContent = "Uploaded ✓";
          } catch (e) {
            console.error(e);
            hidden.value = "";
            if (status) status.textContent = "Upload failed. Try again.";
          }
        });
      }
    });

    toggleLogoUpload(container);
  }

  /* ================= STATE / PROPERTIES ================= */

  function readState(container) {
    const s = {};

    // buttons
    qsa(container, "[data-option][data-value].is-active")
      .forEach(b => { s[b.dataset.option] = b.dataset.value; });

    // text inputs
    qsa(container, "[data-option-input]")
      .forEach(i => { s[i.dataset.optionInput] = i.value.trim(); });

    // selects
    qsa(container, "[data-option-select]")
      .forEach(el => { s[el.dataset.optionSelect] = el.value; });

    // logo url holders -> logo_1_url / logo_2_url
    qsa(container, "[data-logo-url]")
      .forEach(el => { s[`${el.dataset.logoUrl}_url`] = el.value; });

    return s;
  }

  function buildProperties(state) {
    const p = {};

    Object.keys(OPTION_CONFIG).forEach(k => {
      const v = state[k];
      if (v) p[OPTION_CONFIG[k].label] = v;
    });

    // add uploaded logo file urls
    if (state.logo_1 && state.logo_1 !== "None" && state.logo_1_url) {
      p["Logo 1 File"] = state.logo_1_url;
    }
    if (state.logo_2 && state.logo_2 !== "None" && state.logo_2_url) {
      p["Logo 2 File"] = state.logo_2_url;
    }

    return p;
  }

  function buildAddons(state) {
    const ids = [];

    if (state.team_name)    ids.push(ADDON_VARIANTS.team_name);
    if (state.your_name)    ids.push(ADDON_VARIANTS.your_name);
    if (state.front_number) ids.push(ADDON_VARIANTS.front_number);
    if (state.back_number)  ids.push(ADDON_VARIANTS.back_number);

    if (state.material == "Embroidered") ids.push(ADDON_VARIANTS.material_stitched);
    if (state.material == "Sublimated") ids.push(ADDON_VARIANTS.material_print);

    // logo add-on only when location != None
    if (state.logo_1 && state.logo_1 !== "None") ids.push(ADDON_VARIANTS.logo1);
    if (state.logo_2 && state.logo_2 !== "None") ids.push(ADDON_VARIANTS.logo2);

    return ids;
  }

  async function addToCart(items) {
    const res = await fetch("/cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ items })
    });

    if (!res.ok) throw new Error("Add to cart failed");
    return res.json();
  }

  /* ================= UI ================= */

  function bindOptions(container) {
    qsa(container, "[data-option][data-value]").forEach(btn => {
      if (btn.dataset.bound) return;
      btn.dataset.bound = "1";

      btn.addEventListener("click", () => {
        qsa(container, `[data-option="${btn.dataset.option}"]`)
          .forEach(b => b.classList.remove("is-active"));

        btn.classList.add("is-active");
      });
    });
  }
  
  function bindAddonFeeLive(container) {
  // text inputs
  qsa(container, "[data-option-input]").forEach((input) => {
    if (input.dataset.feeBound) return;
    input.dataset.feeBound = "1";

    const key = input.dataset.optionInput; // team_name, your_name...
    const feeEl = container.querySelector(`[data-addon-fee="${key}"]`);
    if (!feeEl) return;

    const update = () => {
      const hasValue = (input.value || "").trim().length > 0;
      feeEl.hidden = !hasValue;
    };

    input.addEventListener("input", update);
    input.addEventListener("change", update);
    update(); // init
  });

  // selects (logo_1, logo_2, material...)
  qsa(container, "[data-option-select]").forEach((select) => {
    if (select.dataset.feeBound) return;
    select.dataset.feeBound = "1";

    const key = select.dataset.optionSelect;
    const feeEl = container.querySelector(`[data-addon-fee="${key}"]`);
    if (!feeEl) return;

    const update = () => {
      const v = (select.value || "").trim();
      const hasValue = v && v !== "None";
      feeEl.hidden = !hasValue;
    };

    select.addEventListener("change", update);
    update();
  });
}

  /* ================= BUNDLE ADD (Prevent double) ================= */

  function bindBundle(container) {
    const form = findForm(container);
    if (!form || form.dataset.bundleBound) return;
    form.dataset.bundleBound = "1";

    form.setAttribute("data-disable-ajax", "true");

    const atcBtn =
      form.querySelector('[data-testid="standalone-add-to-cart"]') ||
      form.querySelector('button[name="add"][type="submit"]') ||
      form.querySelector('button[type="submit"]');

    let isAdding = false;

    const runBundleAdd = async () => {
      if (isAdding) return;
      isAdding = true;

      const state = readState(container);
      const props = buildProperties(state);
      const addons = buildAddons(state);
      const qty = getQty(form);
      const mainVariant = getVariantId(form);
      const key = uuid();

      const items = [{
        id: mainVariant,
        quantity: qty,
        properties: { ...props, _bundle_key: key, _is_main: "1" }
      }];

      addons.forEach(id => {
        items.push({
          id,
          quantity: qty,
          properties: { _bundle_key: key, _is_addon: "1" }
        });
      });

      try {
        await addToCart(items);
        window.location.href = "/cart";
      } finally {
        isAdding = false;
      }
    };

    // 1) Block Horizon click-add (double base)
    if (atcBtn && !atcBtn.dataset.bundleClickBound) {
      atcBtn.dataset.bundleClickBound = "1";

      atcBtn.addEventListener("click", (e) => {
        if (!container.isConnected) return;
        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation();
        runBundleAdd();
      }, true);
    }

    // 2) Block submit (Enter key)
    form.addEventListener("submit", (e) => {
      if (!container.isConnected) return;
      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();

      if (!atcBtn) runBundleAdd();
    }, true);
  }

  /* ================= BOOT ================= */

  function init(container) {
    bindOptions(container);
    bindLogoUpload(container);
    bindAddonFeeLive(container);
    bindBundle(container);
  }

  function boot() {
    document.querySelectorAll("[data-custom-options]").forEach(init);
  }

  document.addEventListener("DOMContentLoaded", boot);
  document.addEventListener("shopify:section:load", boot);
  document.addEventListener("shopify:section:select", boot);

  const mo = new MutationObserver(boot);
  mo.observe(document.documentElement, { childList: true, subtree: true });
  /* ===== BUNDLE REMOVE HANDLER (ADD HERE) ===== */
document.addEventListener(
  "click",
  async (e) => {
    const btn = e.target.closest("[data-bundle-remove]");
    if (!btn) return;

    e.preventDefault();
    e.stopPropagation();

    const bundleKey = btn.dataset.bundleKey;
    const lineKey = btn.dataset.lineKey;

    try {
      const cart = await fetch("/cart.js").then((r) => r.json());

      // Nếu không có bundle -> xóa bình thường
      if (!bundleKey) {
        await fetch("/cart/change.js", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ id: lineKey, quantity: 0 }),
        });
        location.reload();
        return;
      }

      const updates = {};
      cart.items.forEach((it) => {
        if (it.properties && it.properties._bundle_key === bundleKey) {
          updates[it.key] = 0;
        }
      });

      await fetch("/cart/update.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ updates }),
      });

      location.reload();
    } catch (err) {
      console.error("Bundle remove failed:", err);
    }
  },
  true
);

/* ===== END BUNDLE REMOVE HANDLER ===== */
})();
